import { cn } from '@damis/ui/lib/utils'

/**
 * The DAMIS Eval mark (docs/design/design-system/components/Rail): letters on a 6px-cornered ink
 * square, in Archivo's widened 800. "D" for the product (the console's rail, the sign-in card, the
 * install notice); an org's initials where the org app names its org. `onDark` paints it in the
 * brand red with its white letters, for a ground that is already the ink.
 */
export function BrandMark({
  className,
  onDark = false,
  letters = 'D',
}: {
  className?: string
  onDark?: boolean
  letters?: string
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex size-7 shrink-0 items-center justify-center rounded-tile font-heading font-extrabold [font-stretch:115%]',
        letters.length > 1 ? 'text-xs' : 'text-sm',
        onDark
          ? 'bg-sidebar-primary text-sidebar-primary-foreground'
          : 'bg-primary text-primary-foreground',
        className,
      )}
    >
      {letters}
    </span>
  )
}

/** The wordmark's sizes for each place: the phone bar's, the rail's, the sign-in card's. */
const WORDMARK = {
  compact: 'text-15',
  default: 'text-sm',
  large: 'text-xl',
} as const

/**
 * The wordmark: "DAMIS Eval" in Archivo's 700, widened to 110%. Drawn for the eye; the link
 * around it carries the name.
 */
export function Wordmark({ size = 'default' }: { size?: keyof typeof WORDMARK }) {
  return (
    <span
      aria-hidden
      className={cn(
        'font-heading leading-none font-bold tracking-[-0.01em] [font-stretch:110%]',
        WORDMARK[size],
      )}
    >
      DAMIS Eval
    </span>
  )
}
